module.exports = __webpack_public_path__ + "img/6_17_dev_Record.16efeefb.jpg";